import { render, staticRenderFns } from "./ByDept.vue?vue&type=template&id=f51da1b6&scoped=true&"
import script from "./ByDept.vue?vue&type=script&lang=js&"
export * from "./ByDept.vue?vue&type=script&lang=js&"
import style0 from "./ByDept.vue?vue&type=style&index=0&id=f51da1b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51da1b6",
  null
  
)

export default component.exports